<template>
  <div>
    <b-modal size="lg" v-model="showModalVerification" title="Business Verification" hide-footer @hide="onHide">
      <div>
        <b-card-title class="text-capitalize">Facebook Business Manager</b-card-title>
        <b-card-sub-title class="mb-2">
          Input Bussiness ID to get name of Business.
        </b-card-sub-title>
        <b-row class="mb-3">
          <b-col>
            <el-input
              type="text"
              placeholder="Input Facebook Bussiness Manager (FBBM) ID"
              v-model="verificationForm.data.business_id"
              maxlength="512"
              show-word-limit
            />
          </b-col>
        </b-row>
        <div v-loading="loading.submit_verification" v-if="verificationForm.data.business_name">
          <b-card-sub-title class="my-1">Business Name</b-card-sub-title>
          <h6>{{ verificationForm.data.business_name }}</h6>
          <b-card-sub-title class="mt-2">Verification Status</b-card-sub-title>
          <h6 v-if="verificationForm.type == 'verified'">Business Already Verified</h6>
          <h6 v-else-if="verificationForm.type !== 'self'">Mari Works Owned This Whatsapp Business Account</h6>
          <h6 v-else-if="verificationForm.status.length === 0">There is no submitted verification</h6>
          <div v-else class="overflow-auto">
            <b-table responsive striped hover sticky-header :items="verificationForm.status">
              <template #cell(reasons)="data">
                <span v-html="data.value"></span>
              </template>
            </b-table>
          </div>
          <b-row class="my-2" v-if="isEmpty(isApproved) && !isEmpty(verificationForm.data.business_name) && verificationForm.type == 'self'">
            <b-col>
              <b-card-sub-title class="my-2">
                Upload Document Verification
              </b-card-sub-title>
              <b-form>
                <b-form-group
                  id="document-add-file_path-1"
                  label="Business Document : "
                  label-for="document-add-file_path-1">
                  <b-form-file
                    ref="addDocumentFile"
                    required
                    v-model="verificationForm.data.file_path[0]"
                    :accept="accepted_ext['document_whatsapp']"
                    placeholder="Choose a file or drop it here."
                    drop-placeholder="Drop file here."
                  ></b-form-file>
                </b-form-group>
                <b-form-group
                  id="document-add-file_path-2"
                  label="Business Document : "
                  label-for="document-add-file_path-2">
                  <b-form-file
                    ref="addDocumentFile"
                    v-model="verificationForm.data.file_path[1]"
                    :accept="accepted_ext['document_whatsapp']"
                    placeholder="Choose a file or drop it here."
                    drop-placeholder="Drop file here."
                  ></b-form-file>
                </b-form-group>
                <b-form-group
                  id="document-add-file_path-3"
                  label="Business Document : "
                  label-for="document-add-file_path-3">
                  <b-form-file
                    ref="addDocumentFile"
                    v-model="verificationForm.data.file_path[2]"
                    :accept="accepted_ext['document_whatsapp']"
                    placeholder="Choose a file or drop it here."
                    drop-placeholder="Drop file here."
                  ></b-form-file>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
        </div>
        <hr/>
        <div class="d-flex float-right">
          <el-button @click="handlerGetVerificationStatus" :loading="loading.check" v-if="!isEmpty(verificationForm.data.business_id)" size="small" type="info">Check Verification</el-button>
          <el-button @click="submitVerification" :loading="loading.submit" v-if="isValidSubmit && verificationForm.type == 'self'" size="small" type="primary">Submit Document</el-button>
          <el-button @click="onHide" size="small" type="default">Close</el-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import moment from 'moment';
import _ from 'lodash';
// import base64File from '../../../library/base64File';
import popupErrorMessages from '../../../library/popup-error-messages';
import channelAPI from '../../../api/channels';

export default {
  name: 'submitVerification',
  metaInfo: {
    title: 'Submit Verification',
  },
  props: {
    show_form: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show_form() {
      this.showModalVerification = this.show_form;
    },
  },
  beforeCreate() {
    this.isEmpty = _.isEmpty;
  },
  data() {
    return {
      loading: {
        check: false,
        submit: false,
      },
      showModalVerification: false,
      accepted_ext: {
        document_whatsapp: '.pdf, .jpeg, .jpg, .png',
      },
      verificationForm: {
        data: {
          business_id: '',
          business_name: '',
          file_path: [],
        },
        type: '',
        status: [],
      },
    };
  },
  computed: {
    checkUser() {
      return this.$store.state.backOffice.userProfile;
    },
    checkPermission() {
      const users = this.$store.state.backOffice.userProfile;
      const path = this.$router.currentRoute.fullPath;
      const permission = users.permissions.find((v) => path.includes(v.path));
      return permission.configuration;
    },
    isApproved() {
      return this.verificationForm.status.find((v) => ['approved', 'pending'].includes(v.status.toLowerCase()));
    },
    isValidSubmit() {
      return this.verificationForm.data.business_name !== '' && this.verificationForm.data.business_id !== '' && this.verificationForm.data.file_path.length > 0;
    },
  },
  methods: {
    onHide() {
      this.verificationForm = {
        data: {
          business_id: '',
          business_name: '',
          file_path: [],
        },
        type: '',
        status: [],
      };
      this.$emit('onHide');
    },
    async handlerGetVerificationStatus() {
      this.verificationForm.data.business_name = '';
      this.verificationForm.status = [];
      this.verificationForm.type = '';
      const key = this.verificationForm.data.business_id;
      if (key !== '') {
        this.loading.check = true;
        await channelAPI.getVerificationStatus(key)
          .then(async (res) => {
            this.loading.check = false;
            await popupErrorMessages(res);
            if (res.data) {
              this.verificationForm.data.business_id = res.data.business_info.id;
              this.verificationForm.data.business_name = res.data.business_info.name;
              this.verificationForm.type = res.data.type;
              console.log(res.data.status);
              this.verificationForm.status = res.data.status.map((v) => {
                const list_status = {
                  status: v.verification_status,
                  submitted_at: moment(v.submitted_time).format('DD MMM YYYY, HH:mm'),
                  updated_at: moment(v.update_at).format('DD MMM YYYY, HH:mm'),
                  business_id: v.client_business_id,
                  // submitted_info: v.submitted_info
                };
                list_status.reasons = '';
                if (v.rejection_reasons && v.rejection_reasons.length > 0 && v.rejection_reasons[0] !== 'NONE') {
                  list_status.reasons = `- ${v.rejection_reasons.join('<br>- ')}`;
                }
                return list_status;
              });
            }
          }).catch(async (err) => {
            this.loading.check = false;
            await popupErrorMessages(err);
          });
      }
    },
    async submitVerification() {
      this.$confirm(this.$t('channels.confirm.submit_verification'), this.$t('general.confirmation'), {
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        type: 'warning',
        center: true,
        beforeClose: async (action, instance, cb) => {
          if (action === 'confirm') {
            this.loading.submit = true;
            instance.confirmButtonLoading = true;
            const formData = new FormData();
            this.verificationForm.data.file_path.forEach((fl) => {
              if (fl.name) {
                formData.append('files[]', fl);
              }
            });
            formData.append('business_name', this.verificationForm.data.business_name);
            const response = await channelAPI.submitVerification(this.verificationForm.data.business_id, formData).catch(() => {
              this.loading.submit = true;
              instance.confirmButtonLoading = false;
            });
            this.loading.submit = false;
            instance.confirmButtonLoading = false;
            cb();
            await popupErrorMessages(response);
            this.onHide();
            this.$message({
              title: this.$t('general.success'),
              type: 'success',
              message: response.data.message,
              duration: 10 * 1000,
              showClose: true,
            });
          }
          cb();
        },
      });
    },
    showLoader() {
      if (this.loaderStack === 0) {
        this.loader = this.$loading.show();
      }
      this.loaderStack += 1;
    },
    hideLoader() {
      this.loaderStack -= 1;
      if (this.loaderStack === 0) {
        this.loader.hide();
      }
    },
  },
};
</script>
